
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class RuleDeleteDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false;
  loading = false;

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean): void {
    if (!val) {
      this.loading = false;
    }
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  cancel(): void {
    this.dialog = false;
  }

  confirm(): void {
    this.loading = true;
    this.$emit('confirm');
  }
}
